export default {
  PATH_AGENT_AUTHENTCATE: "/compute/partner/authenticate",
  PATH_POLICY_DETAILS: "/consent/v1/getPolicyData",
  API_SEND_OTP:"consent/v1/mobile/sendOtp",
  API_VERIFY_OTP:"consent/v1/verifyOtp",
  API_LEAD_INFO:"lead-info",
  API_SSO_INTI:"init",
  API_LEAD_UPDATE:"lead-status",
  API_RESPONSE_SUCCESS: "success",
  API_RESPONSE_FAILURE: "failure",
  API_RESPONSE_OK: "200 OK",
  API_RESPONSE_CODE_200: 200,
  API_RESPONSE_CODE_400: 400,
  API_RESPONSE_CODE_500: 500,
  API_RESPONSE_CODE_301: 301,
  TNC:"I accept that above details is given correct by me",
  TNC_TIME:"We thank you for having taken the time to confirm the details. We will process your proposal based on the information provided",
  POLICY_DETAIL_URL:"https://online.gateway.manipalcigna.com/TeleMedicalConsent/",
  PATH_GROUP_AFFINITY: "affinity/getdetails", 
};